<template>
  <div>
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备名称：</span>
        </div>
        <el-input v-model="name" size="small" style="width: 280px" />
        <span v-html="nameVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备编号：</span>
        </div>
        <el-input v-model="deviceCode" size="small" style="width: 280px" disabled />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备厂家：</span>
        </div>
        <el-select v-model="deviceManufacturerCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceManufacturerList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备型号：</span>
        </div>
        <el-select v-model="deviceModelCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceModelNameList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">所属楼栋：</span>
        </div>
        <el-select v-model="buildingCode" size="small" style="width: 280px">
          <el-option v-for="item in buildingList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">设备位置：</span>
        </div>
        <el-input v-model="location" size="small" style="width: 280px" />
      </div>


      <!--<div class="form-line">-->
      <!--<div class="textBox">-->
      <!--<b class="red">*</b>-->
      <!--<span class="line-text">设备所在房间：</span>-->
      <!--</div>-->
      <!--<input-tree :fetch="fetchDetail" :showCheckBox="true" @chooseLine="getRoomList" :theValue="roomCode" :theName="roomNumber" style="width: 280px" />-->
      <!--</div>-->


      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">责任人：</span>
        </div>
        <el-select v-model="responsiblePersonCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
        <span v-html="responsiblePersonVer"></span>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="modifyDevice" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {errorHandler} from '../../../utils/errorHandler'
  import {api} from '../../api/WaterManagement'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import {pattern} from '../../../utils/regular'

  export default {
    components: {
      ButtonConfirmNext,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'custom-modify',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧用水',
            name: 'water-over-view'
          }, {
            value: '集中器管理'
          }],
        },
        mainTitle: '修改集中器',
        subheading: '',
        name: '',
        deviceCode: '',
        nameVer: '<span>不超过32个字</span>',
        deviceManufacturerCode: '',
        deviceManufacturerList: [
          {
            name: '大麦物联',
            code: '大麦物联'
          }
        ],
        deviceModelCode: '',
        deviceModelNameList: [
          {
            name: 'DM-IOTC-WC',
            code: 'DM-IOTC-WC'
          }
        ],
        buildingList: [],
        buildingName: '',
        buildingCode: '',
        responsiblePersonCode: '',
        responsiblePersonList: [],
        responsiblePersonVer: '<span>责任人可接收设备离线通知</span>',
        nameHttp: false,
        deviceCodeHttp: false,
        fetchDetail: null,
        location: '',
      }
    },
    created () {
      this.deviceCode = this.$route.params.id
      this.getBuildingList()
      this.getResponsiblePersonList()
      // this.getAlldeviceManufacturer()
    },
    methods: {
      // 获取责任人列表
      getResponsiblePersonList (searchKey) {
        this.$axios.post(`${api.getResponsiblePersonList}?searchKey=${searchKey || ''}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let list = res.data.data
              list.forEach(it => {
                it._value = it.code
                it._label = `${it.name} / ${it.phone}`
              })
              this.responsiblePersonList = list
              this.getwaterByCode()
            }
          })
          .catch(errorHandler('获取责任人列表失败'))
      },

      getAlldeviceManufacturer () {
        this.$axios.post(api.getAllDeviceManufacture, {
          moduleCode: '2',
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.deviceManufacturerList = data
            }
          })
          .catch(errorHandler('获取设备厂家失败'))
      },
      getAllDeviceType () {
        this.$axios.post(api.getAllDeviceType, {
          moduleCode: '2',
          deviceManufactureCode: this.deviceManufacturerCode
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.deviceModelNameList = data
              if (this.deviceModelNameList.length > 0) {
                this.deviceModelName = data[0].code
              }
            }
          })
          .catch(errorHandler('获取设备型号失败'))
      },

      getwaterByCode () {
        this.$axios.get(`${api.getWaterControlDeviceByCode}/${this.deviceCode}`, {})
          .then(res => {
            let data = res.data.data
            this.name = data.name
            this.buildingCode = data.buildingCode
            this.deviceManufacturerCode = data.deviceManufacturerCode
            this.deviceModelCode = data.deviceModelCode
            this.responsiblePersonCode = data.responsiblePersonCode
            this.location = data.location
          })
          .catch(errorHandler('获取设备数据失败'))
      },

      // 获取楼栋列表
      getBuildingList () {
        this.$axios.post(api.getBuildingList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.buildingList = data
            }
          })
          .catch(errorHandler('获取楼栋失败'))
      },

      remoteMethod (query) {
        this.getResponsiblePersonList(query)
      },

      modifyDevice () {
        if (!this.name) {
          this.nameVer = '<span style="color: red;">请输入设备名称</span>'
          return false
        }
        if (!this.nameHttp) {
          return false
        } else {
          this.nameVer = '<span>不超过32个字</span>'
        }
        let obj = {
          name: this.name,
          deviceCode: this.deviceCode,
          deviceManufacturerCode: this.deviceManufacturerCode,
          deviceManufacturerName: '',
          deviceModelCode: this.deviceModelCode,
          deviceModelName: '',
          responsiblePersonCode: this.responsiblePersonCode,
          responsiblePersonName: '',
          responsiblePersonPhone: '',
          buildingName: '',
          buildingCode: this.buildingCode,
          location: this.location
        }
        this.deviceManufacturerList.map(v => {
          if (v.code === this.deviceManufacturerCode) {
            obj.deviceManufacturerName = v.name
          }
        })
        this.deviceModelNameList.map(v => {
          if (v.code === this.deviceModelCode) {
            obj.deviceModelName = v.name
          }
        })
        this.responsiblePersonList.map(v => {
          if (v.code === this.responsiblePersonCode) {
            obj.responsiblePersonName = v.name
            obj.responsiblePersonPhone = v.phone
          }
        })
        this.buildingList.map(v => {
          if (v.code === this.buildingCode) {
            obj.buildingName = v.name
          }
        })
        this.$axios.post(api.updateWaterControlDevice, obj)
          .then(res => {
            nSuccess('修改成功')
            this.strategyCenter()
          })
          .catch(errorHandler('修改失败'))
      },
      strategyCenter () {
        this.$router.push({
          name: 'water-controller-management'
        })
      }
    },
    watch: {
      name (v) {
        let ptn = pattern.basicAndCN.test(v)
        if (!ptn) {
          this.nameVer = '<span style="color: red;">只允许输入中文，字母，数字，下划线</span>'
          this.nameHttp = false
        } else {
          this.nameVer = '<span>不超过32个字</span>'
          this.nameHttp = true
        }
      },
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/WaterManage/ControllerManagement/ControllerModify.vue